enum ErrorMessages {
    REGIONS = 'Error of getting Regions',
    CLUSTERS = 'Error of getting Clusters',
    SCHEMA = 'Error of getting Delivery schema',
    STORES = 'Error of getting Stores info',
    CALENDAR = 'Error of getting Calendar info'
}

export const getInternalServerErrorMessage = (message = '') => {
    switch (message) {
        case ErrorMessages.REGIONS:
            return 'Ошибка получения информации о регионах'
        case ErrorMessages.CLUSTERS:
            return 'Ошибка получения информации о городах'
        case ErrorMessages.SCHEMA:
            return 'Ошибка получения схемы поставки'
        case ErrorMessages.STORES:
            return 'Ошибка получения информации о магазинах'
        case ErrorMessages.CALENDAR:
            return 'Ошибка получения информации о календаре'
        default:
            return message
    }
}
